import { render, staticRenderFns } from "./Expressions.vue?vue&type=template&id=5357c870&lang=html"
import script from "./Expressions.vue?vue&type=script&lang=js"
export * from "./Expressions.vue?vue&type=script&lang=js"
import style0 from "./Expressions.vue?vue&type=style&index=0&id=5357c870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports